import { httpPost } from "../Backend";
import HttpStatusCodes from "../HttpStatusCodes";

export default async function sendBlockRequest(entityName: string, id: string) {
    var response = await httpPost(`api/${entityName}/block`, { id: id })
    return response.status === HttpStatusCodes.Ok;
}